import { formatUOSNumber } from './panelNumbers';

export const reassignSwitchUOS = (switches, switchIdx, selection) => {
  const selectedUOS = formatUOSNumber(selection);
  const currentSwitch = switches[switchIdx];
  const destinationPanel = switches.find(
    (eachSwitch, idx) =>
      idx !== switchIdx &&
      formatUOSNumber(eachSwitch.UOS) === selectedUOS &&
      eachSwitch.deviceMac,
  );
  const panelStaysBehind = switches.some(
    (eachSwitch, idx) =>
      idx !== switchIdx &&
      formatUOSNumber(eachSwitch.UOS) === formatUOSNumber(currentSwitch.UOS),
  );

  return switches.map((eachSwitch, idx) =>
    idx === switchIdx
      ? {
          ...eachSwitch,
          UOS: selectedUOS,
          deviceMac:
            destinationPanel?.deviceMac ??
            (panelStaysBehind ? null : currentSwitch.deviceMac ?? null),
        }
      : eachSwitch,
  );
};
